import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { useTheme } from 'styled-components';
import img from '../../assets/images/exemp.jpg';
import fire from '../../assets/images/fire-white.svg';
import Text from '../../assets/styles/Text';
import { useUpdateReview } from '../../hooks/mutations/useReviewMutations';
import formatTimeAgo from '../../utils/formatTimeAgo';
import * as styles from './styles';

export default function Review({ review, edit = false, colors }) {
  const {
    clientId,
    clientName,
    clientProfilePhoto,
    modelId,
    createdAt,
    score,
    comment,
    show,
  } = review;

  const theme = useTheme();
  const updateReviewMutation = useUpdateReview();

  function handleApprove() {
    if (show) {
      toast.success('Já está aprovado');
      return;
    }

    updateReviewMutation.mutate({
      clientId,
      modelId,
      show: true,
    });
  }

  function handleReject() {
    if (!show) {
      toast.success('Já está rejeitado');
      return;
    }

    updateReviewMutation.mutate({
      clientId,
      modelId,
      show: false,
    });
  }

  function switchText(num) {
    switch (num) {
      case 1:
        return 'Totalmente Frustado';
      case 2:
        return 'Insatisfeito';
      case 3:
        return 'Pode melhorar';
      case 4:
        return 'Gostei';

      default:
        return 'Fodaaaaa';
    }
  }

  const selectColor = edit ? colors : theme.colors.grey.white;
  const isLoading = updateReviewMutation.isPending;

  return (
    <styles.Container $colors={selectColor}>
      <div className="bord" />
      <styles.GroupImg>
        <div>
          <img src={clientProfilePhoto ?? img} alt="perfil" />
          <Text.H3 $bold>{clientName ?? 'Usuário sem nome'}</Text.H3>
        </div>

        <Text.Span>{formatTimeAgo(createdAt)}</Text.Span>
      </styles.GroupImg>

      <styles.GroupText>
        <Text.Span>Avaliação</Text.Span>
        <Text.H3 $bold>
          {switchText(score)} <img src={fire} alt="fire" />
        </Text.H3>
        <Text.P>{comment}</Text.P>

        {edit && !isLoading && (
          <styles.GroupButtons>
            <button type="button" className="green" onClick={handleApprove}>
              <Text.Span $bold>Aprovar</Text.Span>
            </button>

            <button type="button" className="red" onClick={handleReject}>
              <Text.Span $bold>Rejeitar</Text.Span>
            </button>
          </styles.GroupButtons>
        )}

        {isLoading && (
          <styles.GroupButtons>
            <Text.Span>atualizando...</Text.Span>
          </styles.GroupButtons>
        )}
      </styles.GroupText>
    </styles.Container>
  );
}

Review.propTypes = {
  review: PropTypes.any.isRequired,
  edit: PropTypes.bool,
  colors: PropTypes.any,
};
